export default __webpack_public_path__ + "assets/b8e921.png";